/** author: 胡枭 */
import request from '@/utils/request.js'

const baseUrl = process.env.VUE_APP_COMPANY_API
const purchaseUrl = process.env.VUE_APP_PURCHASE_API

//  ------------------------------ 公司认证相关接口 ------------------------------
// 判断当前公司是否已经注册 -- 认证时使用
export function judgeCompanyAlreadyExistedApi(params) {
  return request({
    url: `${baseUrl}/enterprise/companies/exist`,
    method: 'get',
    params
  })
}

// 提交公司信息认证
export function approveCompanyApi(data) {
  return request({
    url: `${baseUrl}/enterprise/companies/certification`,
    method: 'post',
    data
  })
}

// 修改公司信息认证
export function editApproveCompanyApi(data) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/audits`,
    method: 'post',
    data
  })
}

// 查询公司最新的认证信息
export function getCompanyAuditInfoApi() {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/audits/latest`,
    method: 'get'
  })
}

// 开通服务
export function applyServiceApi(data) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/service-audits`,
    method: 'post',
    data
  })
}

// 获取服务审核单信息
export function getServiceAuditStatusApi(serviceType) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/service-audits/type/${serviceType}/latest`,
    method: 'get'
  })
}

// 获取最新的服务审核单信息
export function getLatestServiceAuditStatusApi() {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/service-audits/latest`,
    method: 'get'
  })
}

// 获取企业认证和服务开通的审核状态
// 获取企业所有的审核状态
export function getCompanyAllAuditStatusApi() {
  return request({
    url: `${baseUrl}/enterprise/workbench/audit/status`,
    method: 'get'
  })
}

// ------------------------------ 公司基本信息接口 ------------------------------
// 获取公司信息
export function getCompanyInfoApi() {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself`,
    method: 'get'
  })
}

// 获取公司的工商信息
export function getCompanyBusinessInfoApi() {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/business-info`,
    method: 'get'
  })
}

// 获取公司的基本信息 （联系人信息）
export function getCompanyBaseInfoApi() {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/basic-info`,
    method: 'get'
  })
}

// 公司信息 --- 变更基本信息
export function editCompanyBaseInfoApi(data) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/basic-info`,
    method: 'put',
    data
  })
}

// 公司组织概况
export function getCompanyOrganizeInfoApi() {
  return request({
    url: `${baseUrl}/enterprise/workbench/profile`,
    method: 'get'
  })
}

// 查询灰度配置
export function getGrayReleaseApi() {
  return request(
    {
      url: baseUrl + '/grayscale-releases',
      method: 'get'
    },
    false
  )
}

// 按照公司全称查询公司（不模糊查询）
// 目前仅仅在组织架构的查询公司进行关联时使用，（无法查询自然人）
export function searchCompanyListByFullNameApi(params) {
  return request({
    url: baseUrl + '/enterprise/companies/not-natural-person',
    method: 'get',
    params
  })
}

// 按照公司名称查询代理机构公司 (模糊查询）
export function searchAgencyListApi(params) {
  return request({
    url: `${baseUrl}/enterprise/companies/agency/page`,
    method: 'get',
    params
  })
}

// 按照公司名称查询采购人公司 （模糊查询）
export function searchPurchaserListApi(params) {
  return request({
    url: `${baseUrl}/enterprise/companies/purchaser/page`,
    method: 'get',
    params
  })
}

// 按照公司名称查询供应商公司 （模糊查询）
export function searchSupplierListApi(params) {
  return request({
    url: `${baseUrl}/enterprise/companies/supplier/page`,
    method: 'get',
    params
  })
}

// 按照公司名称查询采购人和代理机构公司 （模糊查询）
export function searchPurchaserOrAgencyListApi(params) {
  return request({
    url: `${baseUrl}/enterprise/companies/purchaser-or-agency/page`,
    method: 'get',
    params
  })
}

// ------------------------------ 组织架构 ------------------------------
// 获取本企业部门列表
export function getDepartmentListApi(params) {
  return request({
    url: `${baseUrl}/enterprise/depts`,
    method: 'get',
    params
  })
}

// 获取本企业部门的详情
export function getDepartmentDetailApi(departmentId) {
  return request({
    url: `${baseUrl}/enterprise/depts/${departmentId}`,
    method: 'get'
  })
}

// 新增本企业部门
export function addDepartmentApi(data) {
  return request({
    url: `${baseUrl}/enterprise/depts`,
    method: 'post',
    data
  })
}

// 修改本企业部门信息
export function editDepartmentDetailApi(data, departmentId) {
  return request({
    url: `${baseUrl}/enterprise/depts/${departmentId}`,
    method: 'put',
    data
  })
}

// 删除本企业部门
export function deleteDepartmentApi(departmentId) {
  return request({
    url: `${baseUrl}/enterprise/depts/${departmentId}`,
    method: 'delete'
  })
}

// 部门排序
export function sortDepartmentApi(data) {
  return request(
    {
      url: `${baseUrl}/enterprise/depts/sort`,
      method: 'put',
      data
    },
    false
  )
}

// 获取企业一级子公司列表
export function getSubCompanyListApi() {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/sub-companies`,
    method: 'get'
  })
}

// 获取子级公司下属企业列表 (层级已被拍平)
// 获取到该子级公司下所有的企业列表（包括多层级的）
export function getSubCompanyUnderlingListApi(subCompanyId) {
  return request(
    {
      url: `${baseUrl}/enterprise/companies/oneself/sub-companies/${subCompanyId}/subordinate-companies`, // 保留，只获取子公司的下属公司
      method: 'get'
    },
    false
  )
}

// 获取子级公司下级企业列表（层级已被拍平）（只获取子一级）
export function getSubCompanySubListApi(subCompanyId) {
  return request(
    {
      url: `${baseUrl}/enterprise/companies/oneself/subordinate-companies/${subCompanyId}/sub-companies`, // 获取下属公司的下属公司
      method: 'get'
    },
    false
  )
}

// 批量查询子公司部门列表（层级已被拍平）
export function getSubCompanyDepartmentListApi(params) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/sub-companies/depts`,
    method: 'get',
    params
  })
}

export function getSubCompanyDepartmentsApi({
  subCompanyId,
  subordinateCompanyId
}) {
  return request({
    url:
      baseUrl +
      `/enterprise/companies/oneself/sub-companies/${subCompanyId}/subordinate-companies/${subordinateCompanyId}/depts`,
    method: 'get'
  })
}

// 关联子公司排序
export function sortSubCompanyApi(data) {
  return request(
    {
      url: `${baseUrl}/enterprise/companies/oneself/sub-companies/sort`,
      method: 'put',
      data
    },
    false
  )
}

// 取消已关联的子公司
export function deleteAssociationSubCompanyApi(subCompanyId) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/disassociate/sub-companies/${subCompanyId}`,
    method: 'post'
  })
}

// 取消已关联的父公司
export function deleteAssociationParentCompanyApi() {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/disassociate/parent-company`,
    method: 'post'
  })
}

// 获取发送出去的关联信息列表
export function getSendAssociationListApi() {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/associate/send-out`,
    method: 'get'
  })
}

// 获取接受到的关联信息列表
export function getAcceptAssociationListApi() {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/associate/receive`,
    method: 'get'
  })
}

// 关联子公司
export function associateSubCompanyApi(data) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/associate/sub-companies`,
    method: 'post',
    data
  })
}

// 关联父公司
export function associateParentCompanyApi(data) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/associate/parent-company`,
    method: 'post',
    data
  })
}

// 同意关联
export function agreeAssociationApi(associationId) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/associate/${associationId}/agree`,
    method: 'post'
  })
}

// 拒绝关联
export function refuseAssociationApi(associationId) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/associate/${associationId}/refuse`,
    method: 'post'
  })
}

// 忽略关联
export function ignoreAssociationApi(associationId) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/associate/${associationId}/ignore`,
    method: 'post'
  })
}

// 取消关联
export function cancelAssociationApi(associationId) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/associate/${associationId}/cancel`,
    method: 'post'
  })
}

// 重新关联
export function againAssociationApi(associationId) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/associate/${associationId}/again`,
    method: 'post'
  })
}

// 查询下属公司管理员信息
export function getSubCompanyAdministratorInfoApi(subordinateCompanyId) {
  return request({
    url: `${baseUrl}/enterprise/companies/oneself/subordinate-companies/${subordinateCompanyId}/administrator`,
    method: 'get'
  })
}

// ------------------------------ 员工管理 ------------------------------
// 获取嘉宾列表 (即正常状态下的员工列表）排除被禁用的员工
export function getNormalEmployeeListApi(params) {
  return request({
    url: baseUrl + '/enterprise/employees/guest/page',
    method: 'get',
    params
  })
}

// 获取拥有 代理机构权限 的员工列表
export function getEmployeeListHasAgencyApi(params) {
  return request({
    url: `${baseUrl}/enterprise/employees/roles/agency/page`,
    method: 'get',
    params
  })
}

// 通过姓名查询员工信息 （后端描述：查询经办人信息，查询统计专用，查询范围为拥有查询统计权限人员，监管范围的员工）
export function getEmployeeByNameApi(params) {
  return request({
    url: `${baseUrl}/enterprise/employees/agent/page`,
    method: 'get',
    params
  })
}

// 查询员工列表 （只查询本公司）（过滤使用）
export function getEmployeeListApi(params) {
  return request(
    {
      url: `${baseUrl}/enterprise/companies/oneself/employees/page`,
      method: 'get',
      params
    },
    false
  )
}

// 查询员工列表（包含下级公司员工，无法过滤员工状态）（员工管理页面使用）
export function getEmployeeManagementListApi(params) {
  return request({
    url: `${baseUrl}/enterprise/employees/manage/page`,
    method: 'get',
    params
  })
}

// 获取员工详情信息（员工管理页面使用）
export function getEmployeeDetailApi(employeeId) {
  return request({
    url: `${baseUrl}/enterprise/employees/${employeeId}`,
    method: 'get'
  })
}

// 新增员工
export function addEmployeeApi(data) {
  return request({
    url: `${baseUrl}/enterprise/employees`,
    method: 'post',
    data
  })
}

// 修改员工信息
export function editEmployeeInfoApi(data) {
  return request({
    url: `${baseUrl}/enterprise/employees/${data.employeeId}`,
    method: 'put',
    data
  })
}

// 禁用员工
export function disableEmployeeApi(employeeId) {
  return request({
    url: `${baseUrl}/enterprise/employees/${employeeId}/disable`,
    method: 'post'
  })
}

// 启用员工
export function enableEmployeeApi(employeeId) {
  return request({
    url: `${baseUrl}/enterprise/employees/${employeeId}/enable`,
    method: 'post'
  })
}

// 删除员工
export function deleteEmployeeApi(data) {
  return request(
    {
      url: `${baseUrl}/enterprise/employees/${data.employeeId}`,
      method: 'delete',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    true,
    true
  )
}

// 移交管理员
export function transferManagerApi(data) {
  return request(
    {
      url: `${baseUrl}/enterprise/employees/${data.toEmployeeId}/administrator`,
      method: 'post',
      data
    },
    false,
    false
  )
}

/** ****************************************** 企业关联接口 **************************************** */
// 收费科目-计费配置列表
export function getChargeItemsApi(params) {
  return request({
    url: `${purchaseUrl}/workbench/enterprises/charge-configs`,
    method: 'get',
    params
  })
}

// 收费科目-机构收费配置详情
export function getChargeConfigDetailApi(configId) {
  return request({
    url: `${purchaseUrl}/charge-openness/${configId}/detail`,
    method: 'get'
  })
}

// 收费科目-获取计费模板详情
export function getChargeItemDetailApi(params) {
  return request({
    url: `${purchaseUrl}/charge-openness/configs/${params.configId}/templates/${params.templateId}/detail`,
    method: 'get'
  })
}

// 前端主动计算收费
export function getComputeFeeApi(params, configId) {
  return request(
    {
      url: `${purchaseUrl}/workbench/charge-configs/${configId}/compute-fee`,
      method: 'get',
      params
    },
    false
  )
}

// 计算平台使用费(招标)
export function getBidPlatformFeeApi(params, configId) {
  return request(
    {
      url: `${purchaseUrl}/workbench/charge-configs/${configId}/bidding-platform-fee`,
      method: 'get',
      params
    },
    false
  )
}

// 查询供应商待支付服务费项目列表
export function getUnpaidChargeListApi(params) {
  return request({
    url: `${purchaseUrl}/workbench/supplier/wait-paid-orders/service-fee`,
    method: 'get',
    params
  })
}

// ------------------------------ 登录日志 ------------------------------

// 统计日志数据
export function getCompanyLoginLogCountApi(params) {
  return request({
    url: `${baseUrl}/login-log/count`,
    method: 'get',
    params
  })
}

// 分页查询公司登录日志
export function getCompanyLoginLogListByPageApi(params) {
  return request({
    url: `${baseUrl}/login-log/page`,
    method: 'get',
    params
  })
}

// 查询访问趋势
export function getCompanyLoginLogTrendApi(params) {
  return request({
    url: `${baseUrl}/login-log/trend`,
    method: 'get',
    params
  })
}

// 查询访问量排名
export function getCompanyLoginLogVisitRankApi(params) {
  return request({
    url: `${baseUrl}/login-log/visit/rank`,
    method: 'get',
    params
  })
}

// 查询访客量排名
export function getCompanyLoginLogVisitorRankApi(params) {
  return request({
    url: `${baseUrl}/login-log/visitor/rank`,
    method: 'get',
    params
  })
}
